<template src="./NotificationsDashboard.html"> </template>

<script>

import { mapState, mapActions } from 'vuex';

import Chart from "@/components/Chart/Chart.vue";

export default {
    name: 'NotificationsDashboard',
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    components: {
        Chart
    },
    data() {
        return {
            accumulatedChart: true,
        }
    },
    computed: {

        ...mapState({
            pixelData: state => state.pixel.variablePixelData,
            pixelDataLast: state => state.pixel.pixelDataLast,

            pixelDataLoading: state => state.pixel.pixelDataLoading,

            variables: state => state.variables.variables,
        }),

        getTableEventsData() {
            return {
                header: [{text: 'Date', value:'date'}, {text: this.variables[this.params.variable.id].description, value: this.params.variable.id}],
                data: this.pixelData, //this.params.notifications.filter(item => item.type == 'accumulated')
            }
        },

        getNotificationsTable() {

            if (!this.pixelData) return [];
            if (this.pixelData.length == 0) return [];

            // let retData = [];
            // for (let i = 0 ; i <  this.pixelDataLast.length ; i++) {
            //     retData.push({
            //         'chillH': this.pixelData[i]? this.pixelData[i][this.params.variable.id] : 0,
            //         'chillH_last': this.pixelDataLast[i][this.params.variable.id]
            //     });
            // }
            console.log('oi": ', this.variables, this.params.variable)
            return {
                header: [{text: 'Date', value:'date'}, {text: this.variables[this.params.variable.id].description, value: this.params.variable.id}, {text: 'Notification Periodicity', value: 'notificate_on'}],
                data: this.pixelData.map(element => {
                    element['notificate_on'] = 'Daily';
                    //element[this.params.variable.id] = retData.map(el => el[this.params.variable.id]);
                    //element[this.params.variable.id + '_last'] = retData.map(el => el[this.params.variable.id + '_last']);
                    return element
                })
            }
        },

        getPixelDataStats() {

            if (!this.pixelDataLast) return [];
            if (this.pixelDataLast.length == 0) return [];

            if (!this.pixelData) return [];
            if (this.pixelData.length == 0) return [];

            let sum = 0;

            // get Last Data from Pixel
            let last = this.pixelData[this.pixelData.length - 1];
            last = last.date.split('-');
            let ret = sum;
            this.pixelDataLast.forEach( (pdl) => {
                let dt = pdl.date.split('-');
                if (dt[1] == last[1] && dt[2] == last[2]) {
                    sum += parseFloat(pdl[this.params.variable.id]);
                    ret = sum;
                    return ret;
                } else {
                    sum += parseFloat(pdl[this.params.variable.id]);
                }
            });

            return ret;

        //    pixelDataLast.reduce((sum, el) => {
        //        el[params.variable.id] + sum
        //    }, 0);

            // if (!this.pixelData) return [];
            // if (this.pixelData.length == 0) return [];

            // let min = this.pixelData[0], max = this.pixelData[0];

            // for (let i = 1, len = this.pixelData.length; i < len; i++) {
            //     let v = this.pixelData[i];
            //     min = (v[this.params.variable.id] < min[this.params.variable.id]) ? v : min;
            //     max = (v[this.params.variable.id] > max[this.params.variable.id]) ? v : max;
            // }

            // return { min: min, max: max};
        },

        getNotificationsChartData() {

            if (!this.pixelData) return [];
            if (this.pixelData.length == 0) return [];

            if (!this.pixelDataLast) return [];
            if (this.pixelDataLast.length == 0) return [];
            
            return [{
                x: this.pixelDataLast.map(el => el.date),
                y: this.accumulatedChart ? this.pixelData.map((sum => value => sum += value[this.params.variable.id])(0)) : this.pixelData.map(el => el[this.params.variable.id]),
                type: 'scatter', //this.accumulatedChart ? 'scatter' : 'bar',
                name: 'Season Observation'
            }, {
                x: this.pixelDataLast.map(el => el.date),
                y: this.accumulatedChart ? this.pixelDataLast.map((sum => value => sum += value[this.params.variable.id])(0)) : this.pixelDataLast.map(el => el[this.params.variable.id]),
                type: 'scatter', //this.accumulatedChart ? 'scatter' : 'bar',
                name: 'Last Season'
            }];

        //     if (this.params.notifications.length == 0) return [];

        //     let weeklyNotifications = this.params.notifications.filter(item => item.type == 'weekly');
        //     let accNotifications = this.params.notifications.filter(item => item.type == 'accumulated');
            
        //     return [{
        //         x: weeklyNotifications.map(el => el.date),
        //         y: this.accumulatedChart ? weeklyNotifications.map((sum => value => sum += value['chillH'])(0)) : weeklyNotifications.map(el => el['chillH']),
        //         type: this.accumulatedChart ? 'scatter' : 'bar',
        //         name: 'Period Observation'
        //      }, {
        //         x: weeklyNotifications.map(el => el.date),
        //         y: this.accumulatedChart ? weeklyNotifications.map((sum => value => sum += value['chillHHis'])(0)) : weeklyNotifications.map(el => el['chillHHis']),
        //         type: 'scatter',
        //         name: 'Historical Average'
        //     }, {
        //         x: accNotifications.map(el => el.date),
        //         y: accNotifications.map(el => el.chillH),
        //         type: 'scatter',
        //         mode: 'markers',
        //         name: 'Accumulated Event'
        //     }
        //     ];
        }
    },
    methods: {

        ...mapActions('pixel', {
            loadModelData: 'getPixelModelData'
        }),

        onBackClick() {
            this.$emit('clicked', this.params);
        }
    },
    mounted() {
        this.loadModelData({
            variable: {
                id: this.params.variable.id,
                threshold: [32, 45]
            },
            interval: this.params.interval,
            latitude: this.params.ws.loc.lat,
            longitude: this.params.ws.loc.lon,
            begin: this.params.begin.replace(/[-_]/g,'') + '00',
            end: this.params.end.replace(/[-_]/g,'') + '23',
            season: 'season'
        });

        let lastBegin = this.params.begin.split('-');
        lastBegin = (parseInt(lastBegin[0]) - 1) + '-' + lastBegin[1] + '-' + lastBegin[2];
        let lastEnd = this.params.end.split('-');
        lastEnd = (parseInt(lastEnd[0]) - 1) + '-' + lastEnd[1] + '-' + lastEnd[2];
        console.log('last season uai: ', lastEnd, ' current uai ', this.params.end)
        this.loadModelData({
            variable: {
                id: this.params.variable.id,
                threshold: [32, 45]
            },
            interval: this.params.interval,
            latitude: this.params.ws.loc.lat,
            longitude: this.params.ws.loc.lon,
            begin: lastBegin.replace(/[-_]/g,'') + '00',
            end: lastEnd.replace(/[-_]/g,'') + '23',
            season: 'last'
        });
    },
}
</script>

<style lang="scss" src="./NotificationsDashboard.scss"> </style>